import { render } from "./AddInventaire.vue?vue&type=template&id=748996bc&scoped=true&ts=true"
import script from "./AddInventaire.vue?vue&type=script&lang=ts"
export * from "./AddInventaire.vue?vue&type=script&lang=ts"

import "./AddInventaire.vue?vue&type=style&index=0&id=748996bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748996bc"]])

export default __exports__